import {
  usePrivateSyncAction,
  UseSyncActionProps,
} from 'modules/integrations/hooks/usePrivateSyncAction'
import { SecondaryActionItem } from '@factorialco/f0-react/dist/experimental'
import { useFeatures } from 'modules/core/hooks/useFeatures'

const EMPTY_ACTIONS: SecondaryActionItem[] = []

type UseDataCollectionSyncActionReturn = {
  dataCollectionSyncActions: SecondaryActionItem[]
  syncModal: React.ReactNode | null
}

export const useDataCollectionSyncAction = (
  props: UseSyncActionProps = {}
): UseDataCollectionSyncActionReturn => {
  const { has_dev_integrations_sync_bar } = useFeatures(['dev_integrations_sync_bar'])
  const { syncActions, syncModal } = usePrivateSyncAction(props)

  // When the SyncBar is active it owns the sync/export action,
  // so the data-collection secondary action must be suppressed.
  if (has_dev_integrations_sync_bar) {
    return {
      dataCollectionSyncActions: EMPTY_ACTIONS,
      syncModal: null,
    }
  }

  return {
    dataCollectionSyncActions: syncActions,
    syncModal,
  }
}
